// 审批
export default [{
  name: 'vipSpgzGetInfo',
  method: 'get',
  desc: '获取审批规则详情',
  path: '/obt/vipSpgzGetInfo',
  params: {
    spgzId: ''
  }
},{
  name: 'vipSpkzNeedApproval',
  method: 'post',
  desc: '获取审批规则id  用于送审',
  path: '/obt/vipSpkzNeedApproval',
  params: {
    bookEmpId: '', // 预订人
    djlx: '',
    ifViolate: '', // 是否违背1.违背0.不违背
    projectId: '',
    travelEmpIds: ''
  }
}, {
  name: 'vipOrderAppProgress',
  method: 'post',
  desc: '获取审批进度详情',
  path: '/obt/vipOrderAppProgress',
  params: {
    orderId: '',
    orderType: ''
  }
}, {
  name: 'vipBpmSendAppNew',
  method: 'post',
  desc: '送审',
  path: '/obt/vipBpmSendAppNew',
  params: {
    againApp: '',
    orderId: '',
    orderNo: '',
    orderType: '',
    sendApps: [],
    spgzId: '',
    sentRemark: '',
    vipBpmPersonnels: []
  }
}, {
  name: 'vipBpmRevertAppNew',
  method: 'post',
  desc: '撤回审批',
  path: '/obt/common/vipBpm/cancelApp',
  params: {
    orderId: '',
    orderType: '',
  }
}, {
  name: 'vipBpmForMyAppNew',
  method: 'get',
  desc: '获取待我审批列表',
  path: '/obt/vipBpmForMyAppNew',
  params: {
    pageNum: 1,
    count: 10,
    person: '',
    approveType:0
  },
  loading: '0'
}, {
  name: 'vipBpmForMyAppCountNew',
  method: 'post',
  desc: '获取待我审批列表数量',
  path: '/obt/vipBpmForMyAppCountNew',
  params: {
    pageNum: 1,
    count: 10,
    person: '',
    approveType:0
  },
  loading: '0'
}, {
  name: 'vipBpmForMyAppedNew',
  method: 'get',
  desc: '获取我已审批列表',
  path: '/obt/vipBpmForMyAppedNew',
  params: {
    pageNum: 1,
    count: 10,
    person: '',
    approveType:0
  },
  loading: '0'
}, {
  name: 'vipBpmForPendingMyAppCount',
  method: 'post',
  desc: '待我审批、我提交的审批数量',
  path: '/obt/vipBpmForPendingMyAppCount',
  params: {
    approveType:0
  },
  loading: '0'
}, {
  name: 'vipBpmReceiveAppResult',
  method: 'post',
  desc: '保存审批结果',
  path: '/obt/vipBpmReceiveAppResult',
  params: {
    appRemark: '', // 审批备注
    completeState: null, // 审批是否通过(0.未通过1.通过)
    completeWay: null, // 审批方式(1.PC2.手机app3.邮件4.短信)
    orderId: '', // 订单Id
    phoneNumber: null, // 手机号
    workItemId: '', // 工作项id
  }
},{
  name: 'spgzFindList',
  method: 'get',
  desc: '审批规则列表',
  path: '/obt/spgzFindList',
  params: {
  }
},{
  name: 'orderApproveList',
  method: 'post',
  desc: '审批规则列表',
  path: '/obt/orderApproveList',
  params: {
    dateEnd: '',
    dateStart: '',
    orderForms: [],
    orderId: '',
    orderType: '',
    orderNo: ''
  }
},{
  name: 'vipSpgzFindDetail',
  method: 'get',
  desc: '获取到审批规则名称',
  path: '/obt/vipSpgzFindDetail',
  params: {
    gzid:''
  }
},{
  name: 'matchGz',
  method: 'post',
  desc: '获取默认审批规则',
  path: '/obt/common/vipBpm/matchGz',
  params: {
    projectId:'',
    empId:'',
    deptId:'',
    cplx:''
  },
  loading:'0'
}

]
